import React from 'react';
import { Helmet } from 'react-helmet-async';
import Banner from "../Banner/Banner";
import Footer from "../Footer/Footer";
import GuideForBooking from "./GuideForBooking";
import TokenRequest from "./TokenRequest";
// import Calendar from "./Calendar";
import CalenderAfterSetHolidays from "./CalenderAfterSetHolidays"

function Index(props) {
    return (
        <div>
            <Helmet defer={false}>
                <title>Book a Podiatry Appointment | Love Your Feet Auckland</title>
                <meta
                    name="description"
                    content="Book online with Love Your Feet Podiatry. Browns Bay clinic Tuesday to Thursday, Milford clinic Friday."
                />
                <link rel="canonical" href="https://loveyourfeet.co.nz/appointment" />
            </Helmet>
            <Banner/>
            <GuideForBooking/>
            <TokenRequest/>
            <CalenderAfterSetHolidays />
            <Footer/>
        </div>
    );
}


export default Index;